function isUpdating(updatingKeys, itemId) {
  const key = lodash.find(updatingKeys, (k) => k.id == itemId)

  return key && key.updating
}

function forceLoad() {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get("force")
  } catch(error) {
    console.log(error)
    return null
  }
}

function handedOut(abloyKey, lease) {
  if (abloyKey && abloyKey.where_at === 'HANDED_OUT') {
    //CHECK IS SAME PERSON
    return !!getCustomerId(abloyKey, lease);
  }
}

function getCustomerId(abloyKey, lease) {
  if (abloyKey) {
    const keyHolderId = abloyKey.key_holder_identity;
    if (keyHolderId && lease.primary_customers && lease.primary_customers.length) {
      const found = lodash.find(lease.primary_customers, customer => {
        const abloyCustomer = customer.abloy_customer;
        const abloyCustomerId = abloyCustomer && abloyCustomer.identity ? abloyCustomer.identity : 'loas-' + customer.id;
        return abloyCustomerId === keyHolderId
      });
      return found ? found.id : null
    }
  }
}

function invalidToActivate(abloyDetails, lease, possibleErrors = null) {
  if (!abloyDetails) { return }

  if (!possibleErrors) {
    possibleErrors = ['is_busy', 'broken', 'wrong_customer', 'lost']
  }

  const error_on = (error_key) => {
    return lodash.find(possibleErrors, (item) => item === error_key)
  }

  if (abloyDetails.is_busy && error_on('is_busy')) {
    return 'Avain on ohjelmoitavissa, ole hyvä ja odota';
  } else if (abloyDetails.operational_status !== 'OPERATIONAL' && error_on('broken')) {
    return 'Avain on rikki';
  } else if (abloyDetails.where_at === 'HANDED_OUT' && !handedOut(abloyDetails, lease) && error_on('wrong_customer')) {
    return 'Avaimella on jo ennestään omistaja, tarkista tiedot'
  } else if (abloyDetails.where_at === 'LOST' && error_on('lost')) {
    return 'Avain on hävinnnyt'
  }
}

function getAbloyKey(abloyKeys, item) {
  const abloyKey = lodash.find(abloyKeys, key => {
    return (key.marking === item.stamp)
  });
  if (!abloyKey) {
    return null;
  } else {
    return abloyKey
  }
}

function getHref(leaseId) {
  if (!leaseId) return null;
  return `/admin/leases/${leaseId}/keys`
}

export {
  forceLoad,
  handedOut,
  getCustomerId,
  invalidToActivate,
  getAbloyKey,
  getHref,
  isUpdating,
}
